import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import MachineIDs from './components/MachineIDs';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/machine-ids" element={<MachineIDs />} />
            </Routes>
        </Router>
    );
}

export default App;
